import { cva } from 'class-variance-authority';

export const wrapperClass = cva([
  'flex',
  'flex-col',
  'items-center',
  'justify-center',
  'w-full',
  'p-6',
  'pt-6',
  'pb-0',
  'max-w-[320px]',
  'rounded-lg',
  'bg-white',
  'shadow-[0px_4px_15px_0px_#dcdcdc]',
]);

export const dateInputWrapperClass = cva(['w-full', 'relative']);

export const datePickerContainerClass = cva(['bg-white shadow-card'], {
  variants: {
    error: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    error: false,
  },
});

export const validationMessageClass = cva(['absolute', 'text-[14px]', 'font-[DMSans,DM Sans,sans-serif]'], {
  variants: {
    error: {
      true: 'font-semibold text-red-500',
      false: '',
    },
    hasLabel: {
      true: 'top-[75px]',
      false: 'top-[65px]',
    },
  },
  compoundVariants: [
    {
      error: false,
      class: 'font-normal text-neutral-700',
    },
  ],
  defaultVariants: {
    error: false,
    hasLabel: false,
  },
});